import {
    Autocomplete,
    TextField,
    createFilterOptions,
} from "@mui/material"
import React from "react"
import _ from "lodash"
import {getOptions} from "../../../../anwendungskonfigurator/misc/widget-functions"

// Aus uwpplus-frontend migriert. Anpassung an VW: fehlenden lodash-Import ergänzt,
// getOptions aus dem anwendungskonfigurator-Submodul.
const filter = createFilterOptions()

const MultiFreeInputSelectWidget = ({
    widget,
    value,
    selectOptions,
    onValueChange,
    disabled,
}) => {
    const options = selectOptions ? selectOptions : getOptions(widget)

    const onChange = (event, newValue) => {
        onValueChange(
            newValue.map((entry) =>
                _.isString(entry) ? entry : entry.inputValue,
            ),
        )
    }

    const filterOptions = (options, params) => {
        const filtered = filter(options, params)

        const {inputValue} = params
        const isExisting = options.some((option) => inputValue === option.title)
        if (inputValue !== "" && !isExisting) {
            filtered.push({
                inputValue,
                title: `"${inputValue}" hinzufügen`,
            })
        }

        return filtered
    }

    return (
        <Autocomplete
            multiple
            disabled={disabled}
            value={value ?? []}
            onChange={onChange}
            filterOptions={filterOptions}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={options ?? []}
            getOptionLabel={(option) => {
                if (typeof option === "string") {
                    return option
                }
                if (option.inputValue) {
                    return option.inputValue
                }
                return option.title
            }}
            renderOption={(props, option) => {
                const {key, ...optionProps} = props
                return (
                    <li
                        key={key}
                        {...optionProps}>
                        {option.title}
                    </li>
                )
            }}
            sx={{width: "100%"}}
            freeSolo
            renderInput={(params) => <TextField {...params} />}
        />
    )
}

export default MultiFreeInputSelectWidget
